import React from "react";
import DataTable from "react-data-table-component";
import InputTargetKorwil from "./SetTargetKorwil";
import CurrencyInput from "react-currency-input-field";
import Swal from "sweetalert2";
import moment from "moment";
import Select from "react-select";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllTargetKorwil } from "stores";
import { getAllClient } from "stores";
import { editTargetKorwil } from "stores";

function TargetKorwil() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const auth = useSelector((state) => state.authReducer);
  const [filterClient, setFilterClient] = React.useState(null);
  const [listClient, setListClient] = React.useState([]);
  const [listTargetKorwil, setListTargetKorwil] = React.useState([]);
  const statusInputTarget = useSelector((state) => state.korwilReducer);
  const targetKorwil = useSelector((state) => state.korwilReducer);
  const [searchText, setSearchText] = React.useState("");
  const [nominal, setNominal] = React.useState("");
  const [modalEditTarget, setModalEditTarget] = React.useState(false);
  const [idTarget, setIdTarget] = React.useState("");

  const submitEditTarget = () => {
    // console.log(nominal, idTarget);
    if (nominal === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Nominal tidak boleh kosong",
      });
    } else if (nominal === "0") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Nominal tidak boleh kosong",
      });
    } else if (nominal === undefined) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Nominal tidak boleh kosong",
      });
    } else {
      editTargetKorwil({
        idTarget: idTarget,
        nominal: nominal,
      }).then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.message,
          });
          setModalEditTarget(false);
          getAllTargetKorwil(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message,
          });
        }
      });
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClick = () => {
    dispatch({ type: "SET_STATUS_INPUT_TARGET_KORWIL", data: false });
  };

  const handleFilterChange = (selectedOption) => {
    setFilterClient(selectedOption);
    getAllTargetKorwil(dispatch, { idClient: selectedOption.value });
  };

  React.useEffect(() => {
    let tmp =
      targetKorwil.listTargetKorwil &&
      targetKorwil.listTargetKorwil.map((val) => {
        return {
          ...val,
          action: (
            <>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-edit-${val._id}`}>Edit Target</Tooltip>
                }
              >
                <Button
                  className="btn-icon btn-link p-0" // Pakai gaya link agar lebih bersih
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#10b981", // Emerald Green yang lebih mewah
                    borderRadius: "12px", // Lebih membulat kotak (modern)
                    border: 0,
                    color: "#10b981",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)", // Efek glow tipis
                    transition: "all 0.3s ease",
                    marginTop: 5,
                  }}
                  onClick={() => {
                    setModalEditTarget(true);
                    setIdTarget(val._id);
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#059669";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#10b981";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  {/* Ikon diganti ke pen-to-square agar lebih modern */}
                  <i
                    className="fas fa-pen-nib"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>
            </>
          ),
        };
      });
    setListTargetKorwil(tmp);
  }, [targetKorwil.listTargetKorwil]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
        borderRadius: "15px",
      },
    },
    header: {
      style: {
        display: "none", // Sembunyikan header bawaan jika sudah pakai Card Title
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f8fafc", // Warna abu-abu biru sangat muda (modern)
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569", // Slate 600
        letterSpacing: "0.5px",
      },
    },
    rows: {
      style: {
        minHeight: "60px", // Row lebih tinggi agar tidak sesak
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f1f5f9 !important", // Efek hover saat baris dilewati
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
      },
    },
    pagination: {
      style: {
        border: "none",
        fontSize: "13px",
        color: "#64748b",
      },
    },
  };

  const colTargetKorwil = [
    {
      name: "NO",
      width: "70px",
      center: true,
      cell: (row, index) => (
        <span className="fw-bold text-muted" style={{ fontSize: "12px" }}>
          {index + 1}
        </span>
      ),
    },
    {
      name: "NO KARYAWAN",
      minWidth: "160px",
      center: true,
      cell: (row) => <span className="fw-800 text-dark">{row.nopeg}</span>,
    },
    {
      name: "NAMA KORWIL",
      minWidth: "220px",
      center: false, // Nama biasanya lebih bagus rata kiri
      cell: (row) => (
        <div className="d-flex align-items-center">
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-circle bg-light text-primary fw-800"
            style={{
              width: "35px",
              height: "35px",
              fontSize: "12px",
              border: "1px solid #e2e8f0",
            }}
          >
            {row.nama.charAt(0)}
          </div>
          <span className="fw-900 text-dark">{row.nama}</span>
        </div>
      ),
    },
    {
      name: "BPD / CLIENT",
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <span className="badge badge-pill badge-light border px-3 py-2 fw-700 text-primary">
          {row.namaClient}
        </span>
      ),
    },
    {
      name: "PERIODE",
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {moment(new Date(row.tanggal)).format("MMMM")}
          </div>
          <div className="small text-muted fw-600">
            {moment(new Date(row.tanggal)).format("YYYY")}
          </div>
        </div>
      ),
    },
    {
      name: "TARGET NOMINAL",
      minWidth: "200px",
      center: true,
      cell: (row) => {
        const formattedValue = row.nominal.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        });
        return (
          <span className="fw-900 text-primary" style={{ fontSize: "15px" }}>
            {formattedValue}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "100px",
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      center: true,
      cell: (row) => (
        <div style={{ transform: "scale(1.2)" }}> {row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    getAllTargetKorwil(dispatch, { idClient: "" });
    dispatch({ type: "SET_STATUS_INPUT_TARGET_KORWIL", data: true });
    getAllClient(dispatch);
  }, []);

  React.useEffect(() => {
    getAllTargetKorwil(dispatch, { idClient: "" });
  }, [statusInputTarget.statusInputTarget]);

  return (
    <>
      <Modal
        size="md" // Ukuran MD biasanya lebih pas untuk input single seperti ini dibanding LG
        show={modalEditTarget}
        onHide={() => setModalEditTarget(false)}
        centered // Membuat modal muncul di tengah layar (lebih elegan)
        contentClassName="border-0"
        style={{ backdropFilter: "blur(5px)" }} // Efek blur pada background saat modal muncul
      >
        <Modal.Header closeButton className="border-0 pb-0">
          {/* Header kosong agar tombol close tetap ada namun tidak memakan tempat */}
        </Modal.Header>

        <Modal.Body className="pt-0 px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#f0f9ff",
                borderRadius: "15px",
                color: "#0ea5e9",
              }}
            >
              <i className="fas fa-edit fa-2x"></i>
            </div>
            <h4
              className="fw-900 m-0"
              style={{ color: "#1e293b", letterSpacing: "-0.5px" }}
            >
              EDIT TARGET
            </h4>
            <p className="text-muted small">
              Update nominal target koordinator wilayah
            </p>
          </div>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              submitEditTarget();
            }}
          >
            <Form.Group className="mb-4">
              <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                Nominal Target (Rp)
              </label>
              <div
                className="currency-input-wrapper shadow-sm"
                style={{ borderRadius: "12px", overflow: "hidden" }}
              >
                <CurrencyInput
                  className="form-control border-0"
                  style={{
                    height: "55px",
                    fontSize: "18px",
                    fontWeight: "700",
                    paddingLeft: "20px",
                    backgroundColor: "#f8fafc",
                    color: "#0f172a",
                  }}
                  name="nominal"
                  placeholder="Contoh: 10.000.000"
                  prefix="Rp "
                  decimalsLimit={2}
                  value={nominal} // Pastikan value terikat agar sinkron
                  onValueChange={(value) => setNominal(value)}
                />
              </div>
            </Form.Group>

            <div className="d-flex flex-column gap-2">
              <Button
                className="btn-block py-3 fw-800 border-0 shadow-sm animate-press"
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#1e293b",
                  fontSize: "15px",
                  letterSpacing: "0.5px",
                }}
                onClick={submitEditTarget}
              >
                SIMPAN PERUBAHAN
              </Button>
              <Button
                variant="link"
                className="btn-block text-muted fw-700 text-decoration-none small"
                onClick={() => setModalEditTarget(false)}
              >
                Batalkan
              </Button>
            </div>
          </Form>
        </Modal.Body>

        <style>{`
    .fw-800 { font-weight: 800; }
    .fw-900 { font-weight: 900; }
    .animate-press:active { transform: scale(0.98); }
    
    /* Memastikan CurrencyInput tetap terlihat elegan saat difokuskan */
    .currency-input-wrapper:focus-within {
      box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2) !important;
      border: 1px solid #0ea5e9;
    }
    
    .currency-input-wrapper {
      border: 1px solid #e2e8f0;
      transition: all 0.2s ease;
    }
  `}</style>
      </Modal>

      {statusInputTarget.statusInputTarget ? (
        <Container fluid className="pt-3">
          <Row>
            <Col md="12">
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: "15px" }}
              >
                <Card.Header className="bg-transparent border-0 pt-4 px-4">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                    <Card.Title
                      as="h3"
                      className="m-0"
                      style={{
                        color: "#1e293b",
                        textTransform: "uppercase",
                        fontWeight: "900",
                        letterSpacing: "1px",
                        fontSize: "1.25rem",
                      }}
                    >
                      <i className="fas fa-chart-line mr-2 text-primary"></i>
                      Target Koordinator Wilayah
                    </Card.Title>

                    {/* Tombol Set Target dipindah ke header kanan agar lebih balance */}
                    {(auth.role === "super admin" || auth.role === "admin") && (
                      <Button
                        className="btn-fill btn-wd mt-3 mt-md-0 shadow-sm fw-800"
                        variant="info"
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "#0ea5e9",
                          border: 0,
                          padding: "10px 25px",
                        }}
                        onClick={handleClick}
                      >
                        <i className="fas fa-plus-circle mr-2"></i>
                        Set Target
                      </Button>
                    )}
                  </div>
                </Card.Header>

                <hr className="mx-4 my-3" style={{ opacity: "0.1" }} />

                <Card.Body className="px-4">
                  {/* Filter Section */}
                  <Row className="mb-4 align-items-center">
                    {/* Filter Client - Hanya untuk Super Admin */}
                    {auth.role === "super admin" && (
                      <Col md="4" className="mb-3 mb-md-0">
                        <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                          Filter Client
                        </label>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="Pilih Client"
                          value={filterClient}
                          onChange={(selectedOption) =>
                            handleFilterChange(selectedOption)
                          }
                          options={[
                            { value: "", label: "Semua Client" },
                            ...listClient,
                          ]}
                          placeholder="Pilih Client"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderRadius: "10px",
                              padding: "2px",
                              border: "1px solid #e2e8f0",
                            }),
                          }}
                        />
                      </Col>
                    )}

                    {/* Search Bar */}
                    <Col
                      md={auth.role === "super admin" ? "4" : "6"}
                      className="ml-auto"
                    >
                      <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                        Pencarian Cepat
                      </label>
                      <InputGroup className="shadow-none">
                        <InputGroup.Prepend>
                          <InputGroup.Text
                            className="bg-light border-right-0"
                            style={{ borderRadius: "10px 0 0 10px" }}
                          >
                            <i className="fas fa-search text-muted"></i>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                          style={{
                            borderRadius: "0 10px 10px 0",
                            borderLeft: 0,
                            height: "45px",
                            backgroundColor: "#f8fafc",
                          }}
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          placeholder="Cari No. Karyawan atau Nama..."
                        />
                      </InputGroup>
                    </Col>
                  </Row>

                  {/* Table Section */}
                  <div className="table-responsive rounded-lg shadow-sm">
                    <DataTable
                      columns={colTargetKorwil}
                      data={listTargetKorwil.filter(
                        (row) =>
                          row.nopeg
                            .toLowerCase()
                            .includes(searchText.toLowerCase()) ||
                          row.nama
                            .toLowerCase()
                            .includes(searchText.toLowerCase()),
                      )}
                      customStyles={{
                        ...customStyles,
                        header: {
                          style: {
                            display: "none",
                          },
                        },
                        headRow: {
                          style: {
                            backgroundColor: "#f1f5f9",
                            borderTop: "1px solid #e2e8f0",
                            fontWeight: "bold",
                          },
                        },
                        rows: {
                          style: {
                            minHeight: "60px",
                            "&:not(:last-of-type)": {
                              borderBottomStyle: "solid",
                              borderBottomWidth: "1px",
                              borderBottomColor: "#f1f5f9",
                            },
                          },
                        },
                      }}
                      pagination
                      highlightOnHover
                      pointerOnHover
                      responsive
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .fw-900 { font-weight: 900; }
    .shadow-sm { box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important; }
    .rdt_Table { border-radius: 10px !important; }
    
    /* Perbaikan tampilan Select agar konsisten */
    .react-select__control {
      border-color: #e2e8f0 !important;
      box-shadow: none !important;
    }
    
    @media (max-width: 768px) {
      .card-title { font-size: 1rem !important; }
    }
  `}</style>
        </Container>
      ) : (
        <InputTargetKorwil />
      )}
    </>
  );
}

export default TargetKorwil;
